<!-- 协作项目 -->
<template>
    <div class="project">
        <div class="top flex-column-between">
            <div class="address flex-align">
                区域:
                <span :class="{'actived':index==0}" v-for="(item,index) in addList" :key="index">{{ item }}</span>
            </div>
            <div class="line"></div>
            <div class="address flex-align">
                分类:
                <span :class="{'actived':index==0}" v-for="(item,index) in classList" :key="index">{{ item }}</span>
            </div>
        </div>
        <div class="bottom flex-between">
            <div class="item flex-column" v-for="(item,index) in imgs" :key="index" @click="goDetail(item.name,item.id)">
                <img :src="downloadURLImg+item.cover" alt="">
                <span>{{item.name}}</span>
            </div>
        </div>
        <div class="more flex-align-center">展开更多</div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                addList: ['全部','阿拉善', '巴彦淖尔','包头','赤峰','鄂尔多斯','呼和浩特','呼伦贝尔','通辽','乌海','乌兰察布','锡林郭勒盟','兴安盟'],
                classList: ['自然', '人文'],
                imgs: [],
                index:0
            }
        },
        methods: {
            goDetail(name, id) {
                let query = {
                    name,
                    id
                };
                this.$router.push({
                    path: '/detail',
                    query
                })
            },
            // 获取研学基地列表
            getImgs() {
                Api.Home.GetAddress()
                    .then(res => {
                        console.log('基地:', res);
                        this.imgs = res.data
                    })
                    .catch(err => {
                        console.log('err:', err)
                    })
            }
        },
        mounted() {
            this.getImgs()
        },
    };
</script>
<style lang='less' scoped>
    .project {
        width: 1200px;
        margin: 50px auto;
        
        .top {
            cursor: default;
            width: 1200px;
            height: 120px;
            background: #FFFFFF;
            box-shadow: 0px 0px 13px 0px rgba(127, 127, 127, 0.14);
            box-sizing: border-box;
            padding: 23px 38px;

            .address {
                font-size: 16px;
                color: #353535;
                flex-shrink: 0;
                flex-wrap: wrap;
                span {
                    color: #999999;
                    margin-left: 20px;
                    flex-shrink: 0;
                }
                .actived{
                    color: #3B73FE;
                }
            }

            .line {
                width: 100%;
                height: 1px;
                border-bottom: 1px dashed #DDDDDD;
            }
        }

        .bottom {
            margin-top: 30px;
            flex-wrap: wrap;

            .item {
                align-items: center;
                margin-bottom: 30px;
                width: 386px;
                height: 369px;
                background: #FFFFFF;
                box-shadow: 0px 0px 13px 0px rgba(127, 127, 127, 0.14);
                img{
                    width: 100%;
                    height: 275px;
                }
                span{
                    display: block;
                    margin-top: 34px;
                    color: #333333;
                    font-size: 22px;
                }
            }
        }

        .more {
            margin: 50px auto;
            width: 219px;
            height: 50px;
            background: linear-gradient(0deg, #1262E7 0%, #4285F4 100%);
            font-size: 16px;
            color: #fff;
            border-radius: 30px;
        }
    }
</style>